import React from 'react'

const SvgTarget = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.09 3.192l-.88 1.984-2.183 1.212a2 2 0 00-.443 3.163l1.713 1.712a2 2 0 002.12.457l2.84-1.072 1.727 1.782s-.03 1.128 1.002 1.499c1.077.387 2.254-.58 1.985-1.737-.292-1.254-1.547-1.19-1.547-1.19L10.66 9.236l1.057-2.776a2 2 0 00-.53-2.203l-1.93-1.738a2 2 0 00-3.166.674zm1.054 2.543l.778-1.732 1.925 1.732-.736 1.951-1.967-1.95zm-1.39 1.44l1.945 1.934-1.983.741-1.732-1.727 1.77-.948z'
    />
    <path d='M12.473 21.996c-6.071 0-10-5.44-9.421-10.577 0 0 1.418 1.672 2.914 1.394.238 3.002 2.618 6.439 7.123 6.16 3.447-.212 5.707-3.044 5.863-5.966.225-4.194-2.888-6.826-6.116-7.027.214-1.733-1.444-2.914-1.444-2.914 6.945-.514 10.61 4.79 10.61 9.476 0 4.823-3.891 9.454-9.53 9.454z' />
    <path d='M9.973 12.63s.05 1.981 2.207 2.372c.886.16 2.632-.419 2.835-2.264.128-1.161-.797-2.524-2.123-2.74L11.814 8.96l.778-1.984c6.092.561 6.133 6.868 4.124 9.048-2.768 3.255-9.313 2.426-9.74-3.457l2.017-.77.98.833z' />
  </svg>
)

export default SvgTarget
